import { Only } from "./Only";

export const Nothing = () => {
    return <Only when={false} />;
};
